import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { COLORS, INFO_BOX } from '../pages/IndividualPlan/tokens';

export function ExitDefinitionNote() {
  return (
    <Box
      data-testid="exit-definition-note"
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.5,
        bgcolor: INFO_BOX.bg,
        border: `1px solid ${INFO_BOX.border}`,
        borderRadius: '8px',
        p: 2,
      }}
    >
      <InfoOutlinedIcon sx={{ flexShrink: 0, fontSize: 20, color: INFO_BOX.accent, mt: '2px' }} />
      <Typography
        component="p"
        sx={{ color: COLORS.ink, fontSize: 14, lineHeight: 1.5 }}
      >
        <Box component="span" sx={{ fontWeight: 700 }}>
          Exit:
        </Box>{' '}
        {"the student has met your state's criteria to leave the English learner program. Some states call this "}
        <Box component="span" sx={{ fontStyle: 'italic' }}>
          reclassification
        </Box>{' '}
        (RFEP).
      </Typography>
    </Box>
  );
}
